"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactModal = void 0;
const react_1 = __importDefault(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_1 = require("./styled");
const ContactModal = ({ isOpen, onClose, text = 'Please contact us with any questions or feedback.', phone, email }) => {
    return (react_1.default.createElement(wl_ui_kit_1.Modal, { title: "Contact Us", isOpen: isOpen, contentAs: styled_1.StyledModalBody, actions: react_1.default.createElement(wl_ui_kit_1.Button, { text: "Ok", color: "primary", onClick: onClose }), onClose: onClose, onBackgroundClick: onClose },
        react_1.default.createElement(wl_ui_kit_1.Body2, { "$shade": "mediumEmphasis" }, text),
        react_1.default.createElement(styled_1.ModalList, null,
            Boolean(phone) && (react_1.default.createElement(styled_1.ModalListItem, { divider: false },
                react_1.default.createElement(wl_ui_kit_1.ListItemIcon, null,
                    react_1.default.createElement(wl_ui_kit_1.Icon, { name: "phone" })),
                react_1.default.createElement(wl_ui_kit_1.ListItemContent, null,
                    react_1.default.createElement(wl_ui_kit_1.Body2, null, phone)))),
            react_1.default.createElement(styled_1.ModalListItem, null,
                react_1.default.createElement(wl_ui_kit_1.ListItemIcon, null,
                    react_1.default.createElement(wl_ui_kit_1.Icon, { name: "mail_outline" })),
                react_1.default.createElement(wl_ui_kit_1.ListItemContent, null,
                    react_1.default.createElement(styled_1.Email, { href: `mailto:${email}` },
                        react_1.default.createElement(wl_ui_kit_1.Body2, null, email)))))));
};
exports.ContactModal = ContactModal;
